import { Highlight, useHits } from 'react-instantsearch';
import { BaseHit, Hit } from 'instantsearch.js';
import { FC } from 'react';
import type { SendEventForHits } from 'instantsearch.js/es/lib/utils';
import { DangerousHTML } from '../../../shared/components/DangerousHTML';
import { LoadGuard } from './LoadGuard';
import { AlgoliaUtil } from '../../../shared/utils';
import { AlgoliaCollectionHit, NormalizedCollectionHit } from '../../../shared/types';

type CollectionHit = Hit<{
  title: string;
  handle: string;
}>;

const CollectionHit: FC<{
  hit: NormalizedCollectionHit;
  insightsHit: Hit<AlgoliaCollectionHit>;
  sendEvent: SendEventForHits;
}> = ({ hit, insightsHit, sendEvent }) => {
  const onCollectionLinkClick = () => {
    hit.onClickCollectionLink({ insightsHit, sendEvent });
  };

  return (
    <a href={hit.url} aria-label={hit.title} onClick={onCollectionLinkClick}>
      <div className="aa-collection" aria-hidden="true">
        <Highlight
          hit={hit as unknown as Hit<BaseHit>}
          attribute="title"
          highlightedTagName="span"
          classNames={{ highlighted: 'aa-highlight' }}
        />
      </div>
    </a>
  );
};

export const CollectionResults = ({ isBrands, algoliaUtil }: { isBrands: boolean; algoliaUtil: AlgoliaUtil }) => {
  const { hits, sendEvent } = useHits<AlgoliaCollectionHit>();

  const noResultsMessage = isBrands
    ? theme.locales.autocomplete.notFound.brands
    : theme.locales.autocomplete.notFound.collections;

  return (
    <LoadGuard noResultsMessage={<DangerousHTML content={noResultsMessage} />}>
      {hits.map((hit) => (
        <CollectionHit
          key={hit.objectID}
          hit={algoliaUtil.normalizeCollectionHit(hit)}
          insightsHit={hit as Hit<AlgoliaCollectionHit>}
          sendEvent={sendEvent}
        />
      ))}
    </LoadGuard>
  );
};
